export enum DownloadApp {
    pageTitle = 'Congratulations!🎉 You are successfully registered.',
    pageTips = 'We’ve picked some potential dates for you. Download the Meta app to check!',
    downloadNow = 'Download Now',
    pageWarning = 'This is the download link to the App Store or Google Play. Your privacy is under protection.',
}